import { useEffect, useRef } from "react";
import { Paper, Box, Button } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { color } from "framer-motion";

// ✅ 공통 버튼 스타일
const commonButtonStyle = {
  height: 30,
  minHeight: "unset",
  padding: "2px 10px",
  fontSize: "12px",
  alignItems: "center",
  borderRadius: "5px",
  boxShadow: "none",
  backgroundColor: "#ffffff",
  border: "1px solid #0065BD",
};

const SearchArea = ({ 
  children, 
  sx = {}, 
  sx2 = {},
  showSearchButton = true,
  onSearch,   
  searchOnEnter = false,
}) => {
  const onSearchRef = useRef(onSearch);

  useEffect(() => {
    onSearchRef.current = onSearch;
  }, [onSearch]);

  const handleKeyDown = (event) => {
    if (!searchOnEnter || event.key !== "Enter" || event.isComposing) return;

    setTimeout(() => onSearchRef.current?.(), 0);
  };
  
  return (
    <Paper
      variant="outlined"
      onKeyDown={handleKeyDown}
      sx={{
        position: "relative",
        paddingTop: "15px",
        marginBottom: "10px",
        border: "1px solid #A3D4FF",
        background: "#F1F8FF",
        ...sx,
      }}
    >
        {/* 좌측: 검색 조건 */}
        <Box
          display="flex"
          gap={2}
          alignItems="center"
          mb="15px"
          sx={{ px: 2,
            ...sx2,
          }}
        >
          {children}
        </Box>
        {/* 우측: 조회 버튼 */}
        {showSearchButton && (
          <Button
            variant="contained"
            color="primary"
            startIcon={<SearchIcon />}
            onClick={onSearch}
            sx={{
              ...commonButtonStyle,
              position: "absolute",
              right: 16,        // Paper padding 기준
              top: 15,          // 검색영역 상단과 맞춤              
              color: "#004C8F",
              "&:hover": {
                backgroundColor: "#1B8FE0",
                color: "#fff",
              },
            }}            
          >
            조회
          </Button>
        )}      
    </Paper>
  );
};

export default SearchArea;
